module.exports = __webpack_public_path__ + "9e745c2fd1ad206499334bbc9592a923.svg";